import React from 'react';
import { cn } from '../../lib/utils';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  bordered?: boolean;
}
export function Card({
  children,
  className,
  bordered = false
}: CardProps) {
  return <div className={cn('bg-[#1A2A1A] rounded-xl p-6 md:p-8', bordered && 'border border-[#22C55E]/20', 'shadow-xl', className)} data-id="element-203">
      {children}
    </div>;
}